import React, { useState, useEffect, useRef } from "react";
import "./EcommerceProduct.scss"
import { useParams } from 'react-router';
import Header from "../../components/Header/Header";
import ProductsContent from "./ProductsContent";
import { sortByOrderAscending } from "../../helper/helper";
import FiltersComponent from "./FiltersComponent";
import { useDispatch, useSelector } from "react-redux";
import { getEcomProdCategories, getEcomProdCategoriesCount, getEcomProdFilterCategories } from "../../../../../utilities/apiRequests/productRegistryServerRequests";
import arrow from "../../assets/arrow-right.svg"
import { setCategoryProducts, setSelectedCategory } from "../../../../../../../redux/companyDataSlice";

const EcommerceProduct = () => {
    const params = useParams();
    const dispatch = useDispatch()
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "productCategory")
    const companyDetails = useSelector((state) => state.companyData.company)
    const [header, setHeader] = useState("")
    const [isOpen, setIsOpen] = useState(false)
    const [filters, setFilters] = useState({})
    const categories = useSelector((state) => state.companyData.categories)
    const selectedCategory = useSelector((state) => state.companyData.selectedCategory)


    const containerRef = useRef(null);
    const [showRightArrow, setShowRightArrow] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [loading, setLoading] = useState(false);

    const [count, setCount] = useState("0")


    useEffect(() => {
        if (params.category) {
            setHeader(params.category)
        }
    }, [params.category])
    useEffect(() => {
        const scrollContainer = containerRef.current;
        if (scrollContainer) {
            const handleScroll = () => {
                const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
                setShowLeftArrow(scrollLeft > 0);
                setShowRightArrow(scrollLeft + clientWidth + 20 < scrollWidth);
            };

            handleScroll();

            scrollContainer.addEventListener("scroll", handleScroll);
            window.addEventListener("resize", handleScroll);

            return () => {
                scrollContainer.removeEventListener("scroll", handleScroll);
                window.removeEventListener("resize", handleScroll);
            };
        }
    }, [categories]);

    const scrollRight = () => {
        containerRef.current?.scrollBy({ left: 250, behavior: 'smooth' });
    };

    const scrollLeft = () => {
        containerRef.current?.scrollBy({ left: -250, behavior: 'smooth' });
    };

    useEffect(() => {
        fetchCatData()
    }, [selectedCategory])
    const fetchCatData = async () => {
        if (categories.length > 0) {
            setLoading(true)
            await getEcomProdCategories(companyDetails?.OrganisationID, selectedCategory.ProductCategory?.ProductCategoryID).then(async (data) => {
                dispatch(setCategoryProducts(data))
                let countdata = await getEcomProdCategoriesCount(companyDetails?.OrganisationID, selectedCategory?.ProductCategory?.ProductCategoryID)
                setCount(countdata)
                setFilters(data?.ProductFilter?.ProductFilterControls)
                setLoading(false)
            })
            await getEcomProdFilterCategories(companyDetails?.OrganisationID, selectedCategory.ProductCategory?.ProductCategoryID)

        }
    }

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };


    const Components = page?.Components || []
    const getProductsComponents = (component) => {
        switch (component.ID) {
            case "Web-Filter-Component":
                return <FiltersComponent isWeb={true} isOpen={isOpen} filters={filters} />
            case "Web-Products-content":
                return <ProductsContent toggleDrawer={toggleDrawer} components={component.Components} isLoading={loading} count={count} />


            default:
                return <div />
        }

    }
    const getProductsSection = (components) => {
        return (
            <div className="EcommerceContact-content" >

                {sortByOrderAscending(components).map((component, key) => {
                    return getProductsComponents(component)

                })}
            </div>
        )
    }
    const images = [
        "https://i.pinimg.com/736x/15/8f/dd/158fdd965744b4a38eef2c61dfcc5b35.jpg",
        "https://i.pinimg.com/736x/9e/ab/19/9eab19d75aed939b565b1d72536af48e.jpg",
        "https://i.pinimg.com/736x/37/1f/bd/371fbd6574c669620def6d2125b7b014.jpg",
        "https://i.pinimg.com/736x/fb/5e/aa/fb5eaafed6a7f5c5dad0c7908de99e35.jpg",
        "https://i.pinimg.com/736x/22/9d/ab/229dab3a208ed414afce3b866a38bd12.jpg",
        "https://i.pinimg.com/736x/46/ea/7b/46ea7b5def24cb1daad84905e639f88a.jpg",
        "https://i.pinimg.com/736x/85/a8/14/85a81430b481c2fd260e8458d722c887.jpg",
        "https://i.pinimg.com/736x/9e/a8/07/9ea8072e400317b1084470bebc52e1aa.jpg"
    ]
    const getCategories = () => {
        return (
            <div className="EcommerceProduct-category" >
                {showLeftArrow && (
                    <div
                        onClick={scrollLeft}
                        className="arrow-left"
                    >
                        <img alt="" src={arrow} />

                    </div>
                )}

                <div className="EcommerceProduct-category-list" ref={containerRef}>
                    {categories.map((coll, key) => {
                        return (
                            <div
                                className="item-collection"
                                key={key}
                                style={{
                                    backgroundImage: `linear-gradient(
                                        to bottom,
                                        rgba(0, 0, 0, 0) 0%, 
                                        rgba(0, 0, 0, 0.8) 100%
                                      ), url(${images[key]})`
                                }}
                                onClick={() => {
                                    dispatch(setSelectedCategory(coll))
                                }}
                            >
                                <div className="title-text">
                                    {coll?.ProductCategory?.Category.toLowerCase()}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {showRightArrow && (
                    <div
                        onClick={scrollRight}
                        className="arrow-right"
                    >
                        <img alt="" src={arrow} />
                    </div>
                )}
            </div>
        );
    };

    const getComponents = (component) => {
        switch (component.ID) {
            case "Mobile-Filter-Component":
                return <FiltersComponent isWeb={false} isOpen={isOpen} filters={filters} />
            case "Header":
                return <div className="EcommerceProduct-header ">
                    <Header text={header} textAlign="center" />
                    {getCategories()}
                </div>
            case "Products-Content":
                return getProductsSection(component.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="EcommerceProduct">
            {sortByOrderAscending(Components).map((component, key) => {
                return getComponents(component)

            })}
        </div>
    )
}
export default EcommerceProduct